import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Loader2 } from "lucide-react";
import api from "@/lib/api";
import WebsiteRenderer from "@/components/WebsiteRenderer";

export default function PublicSite() {
  const { subdomain } = useParams();
  const [data, setData] = useState(null);
  const [error, setError] = useState(false);

  useEffect(() => {
    api.get(`/sites/${subdomain}`)
      .then(({ data }) => {
        setData(data);
        if (data.website?.seo?.title) document.title = data.website.seo.title;
      })
      .catch(() => setError(true));
  }, [subdomain]);

  if (error) {
    return (
      <div className="min-h-screen flex flex-col items-center justify-center text-center px-6">
        <h1 className="font-heading font-bold text-2xl text-[#09090b]">Site not found</h1>
        <p className="font-body text-[#52525b] mt-2">This website doesn't exist or hasn't been published yet.</p>
      </div>
    );
  }
  if (!data) {
    return <div className="min-h-screen flex items-center justify-center"><Loader2 className="animate-spin" /></div>;
  }
  return <WebsiteRenderer website={data.website} profile={data.profile} editable={false} vp="desktop" />;
}
